export default "__VITE_ASSET__KkCx29F3__"